import {Injectable} from "@angular/core";
import {DropDownValues} from "./kraft/types/DropDownValues";
import {UserRole} from "./type/UserRole";
//import {Vorgang} from "./service/Model/vorgangExtended";
import {VorgangStatus} from "./kraft/types/VorgangStatus";
import {SelectableList} from "./kraft/types/selectableList";
import {SelectItem} from "primeng/api";

@Injectable()
export class Globals {

  private rolle: string = 'test';

  public static MP_LISTE: number = 1;
  public static MP_UPLOAD: number = 2;
  public static MP_DETAIL: number = 3;
  public static MP_MASSE: number = 4;
  public static MP_ADMIN: number = 5;
  public static MP_MASSE_DETAIL: number = 6;

  private T_AUSWAHL_FELD : any = [
/*    "Status", */
    "Anrede VN",
    "Zahlungsweise",
    "Zahlungsart",
    "Abweichender Beitragszahler",
    "Vorsteuerabzugsberechtigung VN",
    "Rechtsform VN",
    "Rechtsform Halter",
    "Abweichender Halter",
    "Anrede Beitragszahler",
    "Anrede Halter",
    "Gewünschter Versicherungsschutz",
    "SFKlasse Haftpflicht",
    "Selbstbeteiligung Teilkasko",
    "SFKlasse Vollkasko",
    "Selbstbeteiligung Vollkasko",
    "Schutzbrief",
    "Auslandsschadenschutz",
    "FahrerPlus-FahrerSchutz",
    "Rabattschutz",
    "AutoNotruf",
    "BonusDrive",
    "Beitragsschutz",
    "WerkstattBonus",
    "WerterhaltGarantie",
    "Eigentumsverhaeltnis zum Fahrzeug",
    "Saisonkennzeichen",
    "Betriebsausgabe",
    "Saisonkennzeichen der Vorversicherung",
    "Produktlinie",
    "Deckung KH"
  ];

  private SPALTE : any = {};
  private T_ANREDE: any[];
  private T_ZAHLUNGSART : any = [];
  private T_ZAHLWEISE : any = [];
  private T_DECKUNG : any = [];
  private T_FINANZIERUNG : any = [];
  private T_PRODUKTLINIE : any = [];
  private T_JA : any = [];
  private T_JA_NEIN : any = [];
  private T_RECHTSFORM  : any = [];
  private T_SFKlasse : any = [];
  private T_VERS_SCHUTZ : any = [];
  private T_SB_TK : any = [];
  private T_SB_VK : any = [];
  private T_EIGENTUM : any = [];
  private T_KENNZEICHEN_ART : any = [];
  private T_TARIFGRUPPE : any = [];
  private T_NUTZERKREIS : any = [];
  private T_NUTZUNGSART : any = [];
  private T_DECKUNG_KH : any = [];
  private T_SONDER_AUS : any = [];
  private T_STATUS : any = [];

  mode: number = Globals.MP_LISTE;

  constructor () {
    // Initialisieren globale Tabellen für die Select-Felder
    this.T_JA.push(DropDownValues.EMPTY);
    this.T_JA.push(DropDownValues.JA);

    this.T_JA_NEIN.push(DropDownValues.EMPTY);
    this.T_JA_NEIN.push(DropDownValues.JA);
    this.T_JA_NEIN.push(DropDownValues.NEIN);

    this.T_STATUS.push(VorgangStatus.OK);
    this.T_STATUS.push(VorgangStatus.NICHT_OK);
    this.T_STATUS.push(VorgangStatus.GESPERRT);
    this.T_STATUS.push(VorgangStatus.GESPERRT_DURCH_PG);
    this.T_STATUS.push(VorgangStatus.ZU_PRUEFEN);
    this.T_STATUS.push(VorgangStatus.EINGESPIELT);
    this.T_STATUS.push(VorgangStatus.NICHT_EINGESPIELT);

    this.T_ANREDE = [];
    this.T_ANREDE.push(DropDownValues.EMPTY);
    this.T_ANREDE.push(DropDownValues.HERR);
    this.T_ANREDE.push(DropDownValues.FRAU);
    this.T_ANREDE.push(DropDownValues.FIRMA);

    this.T_ZAHLWEISE.push(DropDownValues.EMPTY);
    this.T_ZAHLWEISE.push(DropDownValues.MONATLICH);
    this.T_ZAHLWEISE.push(DropDownValues.VIERTELJAEHRLICH);
    this.T_ZAHLWEISE.push(DropDownValues.HALBJAEHRLICH);
    this.T_ZAHLWEISE.push(DropDownValues.JAEHRLICH);

    this.T_ZAHLUNGSART.push(DropDownValues.EMPTY);
    this.T_ZAHLUNGSART.push(DropDownValues.LASTSCHRIFT);
    this.T_ZAHLUNGSART.push(DropDownValues.RECHNUNG);

    this.T_DECKUNG.push(DropDownValues.EMPTY);
    this.T_DECKUNG.push(DropDownValues.HAFTPFLICHT);
    this.T_DECKUNG.push(DropDownValues.TEILKASKO);
    this.T_DECKUNG.push(DropDownValues.VOLLKASKO);

    this.T_DECKUNG_KH.push(DropDownValues.DECKUNG_100_MIO);
    this.T_DECKUNG_KH.push(DropDownValues.DECKUNG_GESETZ);

    this.T_EIGENTUM.push(DropDownValues.EMPTY);
    this.T_EIGENTUM.push(DropDownValues.EIGENTUM_VN);
    this.T_EIGENTUM.push(DropDownValues.FINANZIERUNG);
    this.T_EIGENTUM.push(DropDownValues.LEASING);

    this.T_FINANZIERUNG.push(DropDownValues.EMPTY);
    this.T_FINANZIERUNG.push(DropDownValues.EIGENTUM_VN);
    this.T_FINANZIERUNG.push(DropDownValues.FINANZIERUNG);
    this.T_FINANZIERUNG.push(DropDownValues.LEASING);

    this.T_PRODUKTLINIE.push(DropDownValues.SMART);
    this.T_PRODUKTLINIE.push(DropDownValues.KOMFORT);
    this.T_PRODUKTLINIE.push(DropDownValues.PREMIUM);

    this.T_RECHTSFORM.push(DropDownValues.EMPTY);
    this.T_RECHTSFORM.push(DropDownValues.GBR);
    this.T_RECHTSFORM.push(DropDownValues.OHG);
    this.T_RECHTSFORM.push(DropDownValues.KG);
    this.T_RECHTSFORM.push(DropDownValues.GMBH);
    this.T_RECHTSFORM.push(DropDownValues.GGMBH);
    this.T_RECHTSFORM.push(DropDownValues.GMBH_CO_KG);
    this.T_RECHTSFORM.push(DropDownValues.KGAA);
    this.T_RECHTSFORM.push(DropDownValues.VEREIN_NACH_BGB);
    this.T_RECHTSFORM.push(DropDownValues.EG);
    this.T_RECHTSFORM.push(DropDownValues.GAG);
    this.T_RECHTSFORM.push(DropDownValues.PARTG);
    this.T_RECHTSFORM.push(DropDownValues.PARTNERREEDEREI);
    this.T_RECHTSFORM.push(DropDownValues.GMBHUNDCOKGAA);
    this.T_RECHTSFORM.push(DropDownValues.AGCOKGAA);
    this.T_RECHTSFORM.push(DropDownValues.LTD);
    this.T_RECHTSFORM.push(DropDownValues.AG);
    this.T_RECHTSFORM.push(DropDownValues.EV);
    this.T_RECHTSFORM.push(DropDownValues.KDOER);
    this.T_RECHTSFORM.push(DropDownValues.STIFTUNGDESOEFFENTLICHENRECHTS);
    this.T_RECHTSFORM.push(DropDownValues.ZWECKVERBAND);
    this.T_RECHTSFORM.push(DropDownValues.GEWERKSCHAFT);
    this.T_RECHTSFORM.push(DropDownValues.SONSTIGE);

    this.T_VERS_SCHUTZ.push(DropDownValues.HAFTPFLICHT);
    this.T_VERS_SCHUTZ.push(DropDownValues.TEILKASKO);
    this.T_VERS_SCHUTZ.push(DropDownValues.VOLLKASKO);

    this.T_SB_TK.push(DropDownValues.EMPTY);
    this.T_SB_TK.push(DropDownValues.NUM_0);
    this.T_SB_TK.push(DropDownValues.NUM_150);
    this.T_SB_TK.push(DropDownValues.NUM_300);
    this.T_SB_TK.push(DropDownValues.NUM_500);

    this.T_SB_VK.push(DropDownValues.EMPTY);
    this.T_SB_VK.push(DropDownValues.NUM_300);
    this.T_SB_VK.push(DropDownValues.NUM_500);
    this.T_SB_VK.push(DropDownValues.NUM_1000);

    this.T_KENNZEICHEN_ART.push(DropDownValues.STANDARD);
    this.T_KENNZEICHEN_ART.push(DropDownValues.SAISONKENNZEICHEN);
    this.T_KENNZEICHEN_ART.push(DropDownValues.DIPLOMATENKENNZEICHEN);
    this.T_KENNZEICHEN_ART.push(DropDownValues.OLD_TIMER);
    this.T_KENNZEICHEN_ART.push(DropDownValues.WECHSELKENNZEICHEN);

    this.T_TARIFGRUPPE.push(DropDownValues.EMPTY);
    this.T_TARIFGRUPPE.push(DropDownValues.NORMAL);
    this.T_TARIFGRUPPE.push(DropDownValues.AGRARIER);
    this.T_TARIFGRUPPE.push(DropDownValues.BEAMTE_OEFFTL_DIENST);
    this.T_TARIFGRUPPE.push(DropDownValues.BEAMTE_AUF_LEBENSZEIT);

    this.T_NUTZERKREIS.push(DropDownValues.VERSICHERUNGSNEHMER);
    this.T_NUTZERKREIS.push(DropDownValues.PARTNER);
    this.T_NUTZERKREIS.push(DropDownValues.BELIEBIGE_FAHRER);
    this.T_NUTZERKREIS.push(DropDownValues.FAMILIENFAHRER);
    this.T_NUTZERKREIS.push(DropDownValues.UNBEKANNT);

    this.T_SONDER_AUS.push(DropDownValues.EMPTY);
    this.T_SONDER_AUS.push(DropDownValues.FAHRWERKTUNING);
    this.T_SONDER_AUS.push(DropDownValues.TRIEBWERKTUNING);
    this.T_SONDER_AUS.push(DropDownValues.AUSPUFFTUNING);
    this.T_SONDER_AUS.push(DropDownValues.INNENRAUMTUNING);
    this.T_SONDER_AUS.push(DropDownValues.KAROSSERIETUNING);
    this.T_SONDER_AUS.push(DropDownValues.SONDERLACKIERUNG);
    this.T_SONDER_AUS.push(DropDownValues.SONDERBESCHRIFTUNG);
    this.T_SONDER_AUS.push(DropDownValues.OBERFLAECHE);
    this.T_SONDER_AUS.push(DropDownValues.VERKLEIDUNG);
    this.T_SONDER_AUS.push(DropDownValues.AUDIOSYSTEM);
    this.T_SONDER_AUS.push(DropDownValues.VIDEOSYSTEM);
    this.T_SONDER_AUS.push(DropDownValues.TECH_KOMM);
    this.T_SONDER_AUS.push(DropDownValues.TECH_LEIT);
    this.T_SONDER_AUS.push(DropDownValues.SONST_KFZ_MEHRWERT);
    this.T_SONDER_AUS.push(DropDownValues.SONST_SPEZIAL);

    this.T_NUTZUNGSART.push(DropDownValues.EMPTY);
    this.T_NUTZUNGSART.push(DropDownValues.MEHR_GESCHAEFT);
    this.T_NUTZUNGSART.push(DropDownValues.MEHR_PRIVAT);
    this.T_NUTZUNGSART.push(DropDownValues.SONSTIGE);
    this.T_NUTZUNGSART.push(DropDownValues.NUR_GESCHAEFT);
    this.T_NUTZUNGSART.push(DropDownValues.NUR_PRIVAT);
    this.T_NUTZUNGSART.push(DropDownValues.PRIVAT_GESCHAEAEFT);

    this.T_SFKlasse.push(DropDownValues.SF_M);
    this.T_SFKlasse.push(DropDownValues.SF_0);
    this.T_SFKlasse.push(DropDownValues.SF_S);
    this.T_SFKlasse.push(DropDownValues.SF_1_2);
    for (var i: number = 1; i <= 50; i++) {
      this.T_SFKlasse.push("SF" + i.toString());
    }

    this.SPALTE = {};
    for (let i : number = 0; i < this.T_AUSWAHL_FELD.length; i++) {
      this.SPALTE[this.T_AUSWAHL_FELD[i]] = new SelectableList(this.getSelectValueForSpalte(this.T_AUSWAHL_FELD[i]))
          .getListElements();
    }
  } // constructor Ende

  public getSpaltenFilter (): any {
    return this.SPALTE;
  }

  public getSelectList(spalte : string) : SelectItem[] {
    if (this.SPALTE[spalte])
      return this.SPALTE[spalte].getListElements();
    return [];
  }

  public isAuswahlFeld (spalte : string): boolean {
    for (var i: number = 0; i < this.T_AUSWAHL_FELD.length; i++) {
      if (this.T_AUSWAHL_FELD[i].toString() == spalte) {
        return true;
      }
    }
    return false;
  }

  public getSelectValueForSpalte (spalte: string) : any {
    if (spalte.startsWith("Anrede"))
      return this.T_ANREDE;
    if (spalte.startsWith("Rechtsform"))
      return this.T_RECHTSFORM;
    if (spalte.startsWith("SFKlasse"))
      return this.T_SFKlasse;
    if (spalte.startsWith("BF 17"))
      return this.T_JA;

    if (spalte == 'Status')
      return this.T_STATUS;
    if (spalte == "Zahlungsweise")
      return this.T_ZAHLWEISE;
    if (spalte == "Zahlungsart")
      return this.T_ZAHLUNGSART;
    if (spalte.startsWith("Gewünschter Vers"))    // "==" funzt nicht wg. Abschnitt
      return this.T_VERS_SCHUTZ;
    if (spalte == "Selbstbeteiligung Teilkasko")
      return this.T_SB_TK;
    if (spalte == "Selbstbeteiligung Vollkasko")
      return this.T_SB_VK;
    if (spalte == "Eigentumsverhaeltnis zum Fahrzeug")
      return this.T_EIGENTUM;
    if (spalte == "Produktlinie")
      return this.T_PRODUKTLINIE;

    if (spalte == "Abweichender Beitragszahler"
      || spalte == "Abweichender Halter"
      || spalte.startsWith("Saisonkennzeichen"))
      return this.T_JA_NEIN;

    if (spalte == "Vorsteuerabzugsberechtigung VN"
      || spalte == "Schutzbrief"
      || spalte == "Auslandsschadenschutz"
      || spalte == "FahrerPlus-FahrerSchutz"
      || spalte == "Rabattschutz"
      || spalte == "AutoNotruf"
      || spalte == "BonusDrive"
      || spalte == "Beitragsschutz"
      || spalte == "WerkstattBonus"
      || spalte == "WerterhaltGarantie"
      || spalte == "Betriebsausgabe")
      return this.T_JA;

    if (spalte == "Art des Kennzeichens")
      return this.T_KENNZEICHEN_ART;

    if (spalte == "Tarifgruppe VN")
      return this.T_TARIFGRUPPE;

    if (spalte == "Deckung KH")
      return this.T_DECKUNG_KH;

    if (spalte == "Sonderausstattung Erweitert")
      return this.T_SONDER_AUS;

    if (spalte == "Nutzungsart")
      return this.T_NUTZUNGSART;

    return [];
  }

  public setMode(mode: number) {
    this.mode = mode;
  }

  public getMode():number {
    return this.mode;
  }

  public isModeListe(): boolean {
    return this.mode === Globals.MP_LISTE;
  }

  public isModeDetail(): boolean {
    return this.mode === Globals.MP_DETAIL;
  }

  public isModeMasseDetail(): boolean {
    return this.mode === Globals.MP_MASSE_DETAIL;
  }

  public isModeUpload(): boolean {
    return this.mode === Globals.MP_UPLOAD;
  }

  public isModeMasse(): boolean {
    return this.mode === Globals.MP_MASSE;
  }

  public isModeAdmin(): boolean {
    return this.mode === Globals.MP_ADMIN;
  }

  public isMakler() : boolean {
    return (this.rolle === UserRole.MAKLER)
  }

  public isMaklerBetreuer() : boolean {
    return (this.rolle === UserRole.MAKLERBETREUER)
  }

  public setRolle(rolle: string) {
    this.rolle = rolle;
  }
}
